export const idIsInVar = (id: string, featureFlag: string) =>
  featureFlag?.split(',')?.includes(id)

export const idIsInVarOrVarIsTrue = (id: string, featureFlag: string) =>
  idIsInVar(id, featureFlag) || featureFlag === 'true'

export const isFeatureFlagEnabled = (featureFlag: string) =>
  featureFlag === 'true'
